query emproConfig {
    emproConfig {
      isTokenVerified
      selectedContactStatusIds
    }
}
